export const visit = (vm, at) => {
at({ "en": { "board": { "cards": { "dealSplit": { "tooltip": "Deal Split applied" } } } } });
};